import React, { useState, useEffect } from 'react'
import Layout from '../../Layout'
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock'
import { Link } from 'react-router-dom'
import { Button, Flex, Input, Table, TableColumnsType } from 'antd'
import { SearchProps } from 'antd/es/input'
import { DeleteOutlined, EditOutlined, DownloadOutlined } from '@ant-design/icons'
import CreateImportDataTemplateModal from './Component/TemplateModal/CreateImportDataTemplateModal'
import DetailImportDataTemplateModal from './Component/TemplateModal/DetailImportDataTemplateModal'
import ModalDeleteManager from '../../components/ModalDeleteManager';
import useToast from '../../hook/useToast';
import { mixGetV2, mixDate, mixPostV2, formatNumber } from '../../services/mixin'
import { API_URL_v2 } from "../../env";


const { Search } = Input;
interface DataType {
  key: React.Key
  templateName: string
  date: string
}

const CustomerPoolingDataTemplateManagement: React.FC = () => {
  const pushToast = useToast();
  const [listTemplate, setListTemplate] = useState([] as any)
  const [total, setTotal] = useState(0)
  const [paramTemplate, setParamTemplate] = useState({
    'sort[]': 'id,desc',
    page: 1,
    limit: 100000,
    name: '',
  })
  let wait = false
  const getTemplate = async () => {
    if (wait) {
      return
    }
    wait = true
    const res = await mixGetV2('/api/v1/be/history_files', paramTemplate)
    const res2 = await mixGetV2('/api/v1/be/total_history_file', {})
    wait = false
    if (res.status) {
      setListTemplate([...res.data.items])
    }
    if (res2.status) {
      setTotal(res2.data.total)
    }
  }

  useEffect(() => {
    getTemplate()
  }, [paramTemplate])


  //  SEARCH CHANGE
  const onSearch: SearchProps['onSearch'] = (value, _e, info) => {
    setParamTemplate({ ...paramTemplate, name: value })
  }

  // TABLE COLUMNS
  const columns: TableColumnsType<DataType> = [
    {
      title: 'Hành động',
      dataIndex: '',
      key: 'action',
      render: (_d, row: any) => (
        <Flex align='center' className='gap-10px'>
          <Button className="rs-button rs-button--icon-only" onClick={async () => {
            const link = document.createElement('a');
            link.href = row.url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }}><DownloadOutlined /></Button>

        </Flex>
      ),
    },
    {
      title: 'Tên tiệp',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Tổng dữ liệu',
      dataIndex: 'total',
      key: 'total'
    },
    {
      title: 'Ngày tạo',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (d: any) => (
        mixDate(d)
      ),
    },
  ];

  const [showImportDataTemplateModal, setShowImportDataTemplateModal] = useState(false)
  const [showDetailImportDataTemplateModal, setShowDetailImportDataTemplateModal] = useState(false)
  const [idDetail, setIdDetail] = useState(null as any)

  const [listSource, setListSource] = useState([] as any)
  let wait1 = false
  const getSource = async () => {
    if (wait1) {
      return
    }
    wait1 = true
    const res = await mixGetV2('/api/v1/fe/setting/column_warehouse')
    wait1 = false
    if (res.status) {
      const items = JSON.parse(res.data.value)
      const temp = [] as any
      items.map((val: any) => {
        temp.push({
          value: val.id,
          label: val.name,
        })
        return true
      })
      setListSource([...temp])
    }
  }

  const [listSourceV2, setListSourceV2] = useState([] as any)
  let wait2 = false
  const getSourceV2 = async () => {
    if (wait2) {
      return
    }
    wait2 = true
    const res = await mixGetV2('/api/v1/fe/setting/sources')
    wait2 = false
    if (res.status) {
      const items = JSON.parse(res.data.value)
      const temp = [] as any
      items.map((val: any) => {
        temp.push({
          value: val.id,
          label: val.name,
        })
        return true
      })
      setListSourceV2([...temp])
    }
  }

  useEffect(() => {
    getSource()
    getSourceV2()
  }, [])

  const [IsOpenDelete, setIsOpenDelete] = useState(false)
  const [idDelete, setIdDelete] = useState(null)
  const onConfirmDelete = async () => {
    const res = await mixPostV2(`/api/v1/be/template_excel/${idDelete}`, { _method: 'DELETE', })
    if (res.status) {
      setIsOpenDelete(false)
      pushToast("Thao tác thành công", "success")
      getTemplate()
    } else {
      pushToast("Error!", "warning")
    }
  }

  return (
    <>
      {/* {contextHolder} */}

      <Layout className='customer-list'>
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link>, },
            { title: 'Khách hàng', },
            { title: <Link to="/customer/pooling-data">Gộp dữ liệu khách hàng</Link>, },
            { title: 'Lịch sử tệp import vào CRM', },
          ]}
          title={`Lịch sử tệp import vào CRM (${formatNumber(total)} Khách hàng)`}
          backLink='/customer/pooling-data'
          className='gutter-block-end'
        />

        <Flex vertical>
          {/* Filter block */}
          <div className='filter-block mb-0'>
            <div className='rs-input-search v2 w-full'>
              <Search placeholder="Tìm kiếm" onSearch={onSearch} />
            </div>
          </div>

          <Table
            columns={columns}
            dataSource={listTemplate}
            showSorterTooltip={false}
            rowKey="id"
            className="rs-table"
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 10,
              pageSizeOptions: ['10', '20', '50', '100'],
              showTotal: (total) => `Tổng cộng ${Math.ceil(total / 10)} trang`,
              locale: { items_per_page: ' trang', jump_to: 'Tới' },
              position: ['bottomCenter'],
              className: 'rs-pagination',
              showQuickJumper: false,
            }}
          />
        </Flex>
      </Layout>

      <CreateImportDataTemplateModal
        show={showImportDataTemplateModal}
        listSource={listSource}
        listSourceV2={listSourceV2}
        modalClose={() => { setShowImportDataTemplateModal(false) }}
        modalFinish={() => { setShowImportDataTemplateModal(false); getTemplate() }}
      />

      <DetailImportDataTemplateModal
        show={showDetailImportDataTemplateModal}
        id={idDetail}
        listSource={listSource}
        listSourceV2={listSourceV2}
        modalClose={() => { setShowDetailImportDataTemplateModal(false) }}
        modalFinish={() => { setShowDetailImportDataTemplateModal(false); getTemplate() }}
      />

      <ModalDeleteManager
        isOpen={IsOpenDelete}
        closeModal={() => setIsOpenDelete(false)}
        onConfirm={onConfirmDelete}
        title='Bạn có chắc chắn xóa template này'
        titleDelete='Xóa template'
        content='Dữ liệu sẽ bị xóa vĩnh viễn không thể khôi phục'
      />
    </>
  )
}

export default CustomerPoolingDataTemplateManagement
